import React from "react";
import "react-lazy-load-image-component/src/effects/opacity.css";
//components
import images from "../../../../src/ressources/images";
import { isVideo } from "../../../../src/utils/common";
import { XHRImage as Image } from "../../Media/Image";
//style
import "../WallComponents.scss";

const LAZYLOAD_THRESHOLD = 800;

function SquaredPost(props) {
  switch (props.type) {
    case "image":
      return (
        <Image
          alt={props.imagePreview}
          height={props.height}
          threshold={LAZYLOAD_THRESHOLD}
          src={props.imagePreview}
          width="100%"
        />
      );

    case "video":
      return (
        <>
          <div className="content_squared_post bg_video">
            <img
              className="preview_icon"
              src={images.icon_video_white}
              alt=""
            />
            <Image
              src={props.videoPreview}
              height={props.height}
              threshold={LAZYLOAD_THRESHOLD}
              alt=""
            />
          </div>
        </>
      );

    case "multipleFiles":
      return isVideo(props.extension) ? (
        <>
          <div className="content_squared_post bg_video">
            <img className="preview_icon" src={images.icon_multiple} alt="" />
            <Image
              src={props.videoPreview}
              height={props.height}
              threshold={LAZYLOAD_THRESHOLD}
              alt=""
            />
          </div>
        </>
      ) : (
        <div className="content_squared_post bg_img">
          <Image
            alt={props.imagePreview || props.videoPreview}
            src={props.imagePreview || props.videoPreview}
            height={props.height}
            threshold={LAZYLOAD_THRESHOLD}
          />
          <img className="preview_icon" src={images.icon_multiple} alt="" />
        </div>
      );

    default:
      return (
        <Image
          alt={props.imagePreview}
          height={props.height}
          threshold={LAZYLOAD_THRESHOLD}
          src={props.imagePreview}
        />
      );
  }
}

export default SquaredPost;
